import type { FC } from "react";

import styled from "styled-components";

import { StickyTabs } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export interface ITabItem {
    id: string;
    label: string;
}

interface ISidePanelSwitcherProps {
    items: ITabItem[];
    selectedValue: string;
    onItemClick: (value: string) => void;
}

const StyledStickyTabs = styled(StickyTabs)`
    justify-content: flex-start;
    height: 100%;

    & .react-tabs {
        width: 100%;
        height: 100%;
        
        ul {
            height: 100%;
        }
    }
`;

export const SidePanelSwitcher: FC<ISidePanelSwitcherProps> = ({ items, selectedValue, onItemClick }) => (
    <Flex
        width="100%"
        height="48px"
    >
        <StyledStickyTabs
            activeTab={selectedValue}
            onTabClick={onItemClick}
            items={items.map(({ id, label }) => ({
                id,
                title: label,
            }))}
        />
    </Flex>
);
